(function () {
    'use strict';
    $(document).ready(function () {
        let $wnd = window.innerWidth;
        const mobileBreakpoint = 992;

        //Smooth scroll to
        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');

            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });


        //Menu mobile toggle
        $(".menu-toggle").click(function () {
            $('.header-right nav')
                .fadeToggle()
                .toggleClass('open');
            $('header').toggleClass("open");
            $(this).toggleClass("open");
        });

        //Search trigger
        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            return false;
        });

        // Footer partners swiper
        new Swiper('.partners-swiper', {
            slidesPerView: 6,
            freeMode: true,
            loop: true,
            speed: 5000,
            autoplay: {
                delay: 1,
                disableOnInteraction: false,
            },
            breakpoints: {
                1199: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 3,
                },
                576: {
                    slidesPerView: 2,
                },
                375: {
                    slidesPerView: 1,
                },
            }
        });

        // Header hello bar swiper
        new Swiper('#hello-bar-swiper', {
            slidesPerView: 1,
            direction: "vertical",
            height: 40,
            loop: true,
            speed: 2000,
            autoplay: {
                delay: 5000,
            }
        });

        if(sessionStorage.getItem("hello-bar-closed") === null || sessionStorage.getItem("hello-bar-closed") === true){
            $(".hello-bar").removeClass("closed");
        }

        $(".hello-bar .close").on("click", function (){
            $(".hello-bar").addClass("closed");
            sessionStorage.setItem("hello-bar-closed", true);
        });

        $('ul.header-menu ul.dropdown-menu').each(function () {
            $(this).wrap("<div class='dropdown-wrapper'></div>");
        });

        $('ul.header-menu li.menu-item-has-children > a').on('click', function (e) {
            if ($(this).attr('href') === '#') e.preventDefault();
            const $this = $(this);
            if ($this.hasClass('active')) {
                $this.siblings('.dropdown-wrapper').slideToggle(250);
                $this.toggleClass('active');
            } else {
                if ($('ul.header-menu li.menu-item-has-children > a.active').length) {
                    closeAllSubmenus();
                    setTimeout(function () {
                        $this.siblings('.dropdown-wrapper').slideToggle(250);
                        $this.toggleClass('active');
                    }, 250);
                } else {
                    $this.siblings('.dropdown-wrapper').slideToggle(250);
                    $this.toggleClass('active')
                }
            }
        });

        $(window).resize(function () {
            $wnd = window.innerWidth;
            $('.header-right nav.open').fadeOut(250, function () {
                $(this).css('display', '');
                $(this).removeClass('open');
            });
            $('.menu-toggle').removeClass('open');
            $('header').removeClass('open');
            closeAllSubmenus();
        });

        function closeAllSubmenus() {
            $('ul.header-menu li.menu-item-has-children > a.active').each(function () {
                $(this).siblings('.dropdown-wrapper').slideToggle(250, function () {
                    $(this).css('display', '')
                });
                $(this).removeClass('active')
            });
        }
    });
}(jQuery));
